import { getThdProductDetails } from '../../api/thdApi';

const getThdProductDetailsOrNotItsCool = (skus, storeId) => (
  getThdProductDetails(skus, storeId)
);

export default getThdProductDetailsOrNotItsCool;
